export enum Submitted {
  Unsubmitted,
  Submitted,
  SubmittedAndConfirmed
}
